import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'app-recover',
  templateUrl: './recover.component.html',
  styleUrls: ['./recover.component.css']
})
export class RecoverComponent implements OnInit {
  
  recoverForm : FormGroup | undefined;

  constructor(public translate: TranslateService, public router: Router, private loginService: LoginService, private toast: ToastService) {
    this.translate.setDefaultLang(localStorage.getItem('language_dm7') || 'it');
  }

  ngOnInit(): void {
    this.recoverForm = new FormGroup({
      username: new FormControl(""),
      mail: new FormControl("")
    });
  }


  public async recovery(){
    let body = {
      email: this.recoverForm?.controls.mail.value,
      username: this.recoverForm?.controls.username.value,
    };
    let response = await this.loginService.auth_recovery(body);
    if(response.success){
      this.router.navigate(['/Login']);
    } else {
      this.toast.openToast(response.msg, "error");
    }
  }

}
